import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase';

function EditSingleLegendStats({player, teamId}) {

    // If requested, send in playerObj to get player_parent_id and stats
    const [playerObj, setPlayerObj] = useState();
    const [requestCount, setRequestCount] = useState(0);

    const [fixtures, setFixtures] = useState(player?.fixtures);
    const [goals, setGoals] = useState(player?.goals);
    const [assists, setAssists] = useState(player?.assists);
    const [playerParentId, setPlayerParentId] = useState(player?.player_parent_id)

    const [message, setMessage] = useState("")
    const [error, setError] = useState("")

    useEffect(() => {

        if (requestCount > 0 && player) {
            try {
                const playerRef = firestore.collection("players-fb");
                playerRef.where("player_name", "==", player.player_name).onSnapshot(({docs}) => {
                    const players = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    if (players?.length > 0) {
                        setPlayerObj(players[0])
                        console.log(players)
                        setPlayerParentId(players[0].id)
                    }
                })
            } catch (error) {
                
            }
        }

    }, [requestCount, player])

    async function editSingleStatsHandler(e) {
        e.preventDefault()
        if (!fixtures || !goals || !assists || !player?.id) {
            setError("Fyll ut alle feltene")
            return
        }
        try {
            const legendStatsRef = firestore.collection("teams").doc(teamId).collection("total-stats").doc(player.id)
            const data = {
                fixtures,
                goals, 
                assists,
                player_parent_id: playerParentId || ""
            }
            legendStatsRef.update(data);
            setMessage("Oppdatert")
        } catch (error) {
            console.log(error)
            setMessage("")
            setError("Kunne ikke oppdatere")
        }
    }

    return (
        <div>
            <button onClick={() => setRequestCount(requestCount => requestCount+1)}>Finn spiller</button>
            <form onSubmit={editSingleStatsHandler}>
                <label>Kamper</label>
                <input className="form-control mb-2" value={fixtures} onChange={e => setFixtures(e.target.value)} />

                <label>Mål</label>
                <input className="form-control mb-2" value={goals} onChange={e => setGoals(e.target.value)} placeholder="Mål" />

                <label>Assist</label>
                <input className="form-control mb-2" value={assists} onChange={e => setAssists(e.target.value)} placeholder="Mål" />

                <label>Parent player ID</label>
                <input className="form-control mb-2" value={playerParentId} onChange={e => setPlayerParentId(e.target.value)} />

                {error && <div className="alert alert-danger">{error}</div>}
                {message && <div className="alert alert-success">{message}</div>}
                <button className="btn btn-success btn-block">Lagre endringer</button>
            </form>
        </div>
    )
}
export default EditSingleLegendStats